<template>
  <div class="post-evidence-previous-wrapper">
    <!-- Assessment Rubric -->
    <div class="collapse-wrapper">
      <div v-b-toggle.collapse-1 class="collapse-header collapse-header-wrapper">
        <div class="title-left">
          <span> Assessment Rubric </span>
        </div>
        <svg
          class="icon-expanded"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.29609 11.2086C7.68672 11.5992 8.32109 11.5992 8.71172 11.2086L13.7117 6.20859C14.1023 5.81797 14.1023 5.18359 13.7117 4.79297C13.3211 4.40234 12.6867 4.40234 12.2961 4.79297L8.00234 9.08672L3.70859 4.79609C3.31797 4.40547 2.68359 4.40547 2.29297 4.79609C1.90234 5.18672 1.90234 5.82109 2.29297 6.21172L7.29297 11.2117L7.29609 11.2086Z"
            fill="#3B3E66"
          />
        </svg>
      </div>

      <b-collapse id="collapse-1" class="collapse-body">
        <div class="collapse-content">
          <div
            v-for="criterion in criteria"
            :key="`criterion-${criterion.id}`"
            class="collapse-content__rubric"
          >
            <!-- Pass -->
            <div class="text__criterion">
              <svg width="24" height="24" class="text-info" viewBox="0 0 24 24" fill="currentColor">
                <path
                  d="M9.9997 15.1709L19.1921 5.97852L20.6063 7.39273L9.9997 17.9993L3.63574 11.6354L5.04996 10.2212L9.9997 15.1709Z"
                />
              </svg>
              <div class="text__criterion-title">
                <b>
                  {{ criterion.pass_title }}
                </b>
                <p class="m-0 text__criteria-description">{{ criterion.pass_criterion }}</p>
              </div>
            </div>

            <div
              v-for="additional in criterion.additional_criteria"
              :key="`additional-${additional.id}`"
              class="text__criterion"
            >
              <svg
                width="24"
                height="24"
                class="text-warning"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path
                  d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"
                />
              </svg>
              <div class="text__criterion-title">
                <b>
                  {{ additional.title }}
                </b>
                <p class="m-0 text__criteria-description">{{ additional.description }}</p>
              </div>
            </div>

            <!-- Not Yet -->
            <div class="text__criterion">
              <svg
                width="24"
                height="24"
                class="text-danger"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path
                  d="M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z"
                />
              </svg>
              <div class="text__criterion-title">
                <b>
                  {{ criterion.not_yet_title }}
                </b>
                <p class="m-0 text__criteria-description">{{ criterion.not_yet_criterion }}</p>
              </div>
            </div>
          </div>
        </div>
      </b-collapse>
    </div>

    <!-- Your Previous Evidence -->
    <div class="collapse-wrapper">
      <div v-b-toggle.collapse-2 :class="backgroundCollapse" class="collapse-header-wrapper">
        <div class="collapse-header header__previous-evidence">
          <div class="collapse-header__title">
            <div class="title-left">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                <path
                  d="M2.34375 2.34375L1.28125 1.28125C0.809375 0.809375 0 1.14375 0 1.80938V5.25C0 5.66563 0.334375 6 0.75 6H4.19063C4.85938 6 5.19375 5.19063 4.72188 4.71875L3.75938 3.75625C4.84375 2.67188 6.34375 2 8 2C11.3125 2 14 4.6875 14 8C14 11.3125 11.3125 14 8 14C6.725 14 5.54375 13.6031 4.57188 12.925C4.11875 12.6094 3.49687 12.7188 3.17812 13.1719C2.85938 13.625 2.97187 14.2469 3.425 14.5656C4.725 15.4688 6.30312 16 8 16C12.4187 16 16 12.4187 16 8C16 3.58125 12.4187 0 8 0C5.79063 0 3.79063 0.896875 2.34375 2.34375ZM8 4C7.58437 4 7.25 4.33437 7.25 4.75V8C7.25 8.2 7.32812 8.39062 7.46875 8.53125L9.71875 10.7812C10.0125 11.075 10.4875 11.075 10.7781 10.7812C11.0687 10.4875 11.0719 10.0125 10.7781 9.72188L8.74687 7.69063V4.75C8.74687 4.33437 8.4125 4 7.99687 4H8Z"
                />
              </svg>
              <span> Your Previous Evidence </span>
            </div>
            <!-- status -->
            <div class="criterion-evaluation" :class="badgeStatusClass">
              <svg
                v-if="prevEvaluation.assessment_evaluation.pass"
                width="14"
                height="10"
                viewBox="0 0 14 10"
                fill="currentColor"
              >
                <path
                  d="M13.7086 0.292969C14.0992 0.683594 14.0992 1.31797 13.7086 1.70859L5.70859 9.70859C5.31797 10.0992 4.68359 10.0992 4.29297 9.70859L0.292969 5.70859C-0.0976563 5.31797 -0.0976563 4.68359 0.292969 4.29297C0.683594 3.90234 1.31797 3.90234 1.70859 4.29297L5.00234 7.58359L12.2961 0.292969C12.6867 -0.0976562 13.3211 -0.0976562 13.7117 0.292969H13.7086Z"
                />
              </svg>
              <svg v-else width="10" height="10" viewBox="0 0 10 10" fill="currentColor">
                <path
                  d="M9.70859 1.70859C10.0992 1.31797 10.0992 0.683594 9.70859 0.292969C9.31797 -0.0976562 8.68359 -0.0976562 8.29297 0.292969L5.00234 3.58672L1.70859 0.296094C1.31797 -0.0945313 0.683594 -0.0945313 0.292969 0.296094C-0.0976562 0.686719 -0.0976562 1.32109 0.292969 1.71172L3.58672 5.00234L0.296094 8.29609C-0.0945312 8.68672 -0.0945312 9.32109 0.296094 9.71172C0.686719 10.1023 1.32109 10.1023 1.71172 9.71172L5.00234 6.41797L8.29609 9.70859C8.68672 10.0992 9.32109 10.0992 9.71172 9.70859C10.1023 9.31797 10.1023 8.68359 9.71172 8.29297L6.41797 5.00234L9.70859 1.70859Z"
                />
              </svg>
              <div class="text-evaluation-result">
                {{ evaluationResult }}
              </div>
            </div>
          </div>
          <svg class="icon-expanded" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M7.29609 11.2086C7.68672 11.5992 8.32109 11.5992 8.71172 11.2086L13.7117 6.20859C14.1023 5.81797 14.1023 5.18359 13.7117 4.79297C13.3211 4.40234 12.6867 4.40234 12.2961 4.79297L8.00234 9.08672L3.70859 4.79609C3.31797 4.40547 2.68359 4.40547 2.29297 4.79609C1.90234 5.18672 1.90234 5.82109 2.29297 6.21172L7.29297 11.2117L7.29609 11.2086Z"
              fill="#3B3E66"
            />
          </svg>
        </div>
        <div
          v-if="prevSubmission && prevSubmission.attachments.length > 0"
          class="text-file-attachment"
        >
          <span>{{ prevSubmission.attachments.length }}</span>
          <span> File(s) Attached</span>
        </div>
      </div>

      <b-collapse id="collapse-2" visible class="collapse-body">
        <div class="collapse-content collapse-content__previous-evidence">
          <div v-if="prevSubmission && prevSubmission.description" class="content-text">
            <base-text-editor-display>
              <div v-safe-html="prevSubmission.description" />
            </base-text-editor-display>
          </div>
          <base-files-list
            v-if="prevSubmission && prevSubmission.attachments.length > 0"
            class="content-file-list"
            :attachments="prevSubmission.attachments"
          ></base-files-list>
        </div>
      </b-collapse>
    </div>

    <!-- Feedback from Assessor -->
    <div class="collapse-wrapper">
      <div
        v-b-toggle.collapse-3
        class="collapse-header header__feedback-from-assessor collapse-header-wrapper"
      >
        <div class="title-left">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <g clip-path="url(#clip0_1958_1144)">
              <path
                d="M7.82988 15.2603C9.07306 15.2603 10.4279 15.0175 11.5449 14.4348L14.366 15.5615C14.4534 15.5907 14.5408 15.6004 14.6379 15.6004C14.8905 15.6004 15.143 15.5033 15.3275 15.3187C15.58 15.0662 15.6674 14.7069 15.5703 14.3669L14.4343 11.5454C15.017 10.4381 15.2598 9.08326 15.2598 7.83036C15.2598 3.5472 12.113 0.400391 7.82988 0.400391C3.54671 0.400391 0.399902 3.5472 0.399902 7.83036C0.399902 12.1135 3.54671 15.2603 7.82988 15.2603ZM7.82955 2.00305C11.0444 2.00305 13.657 4.61568 13.657 7.83048C13.657 8.86971 13.3753 9.89922 12.8314 10.8025C12.6955 11.0356 12.6566 11.3075 12.7343 11.5698L13.657 13.6579L11.5688 12.7352C11.3066 12.6575 11.0346 12.6964 10.8015 12.8324C9.89829 13.3665 8.86878 13.6579 7.82955 13.6579C4.61475 13.6579 2.00212 11.0453 2.00212 7.83048C2.00212 4.61568 4.61475 2.00305 7.82955 2.00305Z"
                fill="#255091"
              />
              <path
                d="M5.33354 6.79075H10.3354C10.8696 6.79075 11.3067 6.41926 11.3067 5.9652C11.3067 5.51115 10.8696 5.13965 10.3354 5.13965H5.33354C4.79936 5.13965 4.3623 5.51115 4.3623 5.9652C4.3623 6.41926 4.78965 6.79075 5.33354 6.79075Z"
                fill="#255091"
              />
              <path
                d="M5.33354 10.2292H10.3354C10.8696 10.2292 11.3067 9.85773 11.3067 9.40368C11.3067 8.94962 10.8696 8.57812 10.3354 8.57812H5.33354C4.79936 8.57812 4.3623 8.94962 4.3623 9.40368C4.3623 9.85773 4.78965 10.2292 5.33354 10.2292Z"
                fill="#255091"
              />
            </g>
            <defs>
              <clipPath id="clip0_1958_1144">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span> Feedback from Assessor </span>
        </div>
        <svg class="icon-expanded" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path
            d="M7.29609 11.2086C7.68672 11.5992 8.32109 11.5992 8.71172 11.2086L13.7117 6.20859C14.1023 5.81797 14.1023 5.18359 13.7117 4.79297C13.3211 4.40234 12.6867 4.40234 12.2961 4.79297L8.00234 9.08672L3.70859 4.79609C3.31797 4.40547 2.68359 4.40547 2.29297 4.79609C1.90234 5.18672 1.90234 5.82109 2.29297 6.21172L7.29297 11.2117L7.29609 11.2086Z"
            fill="#3B3E66"
          />
        </svg>
      </div>

      <b-collapse id="collapse-3" visible class="collapse-body">
        <div class="collapse-content">
          <base-text-editor-display>
            <div v-safe-html="prevEvaluation.description" />
          </base-text-editor-display>
        </div>
      </b-collapse>
    </div>
  </div>
</template>

<script>
import BaseFilesList from '@/components/base-components/BaseFilesList';
import BaseTextEditorDisplay from '@/components/base-components/BaseTextEditorDisplay';
import PostResponse from '@/models/PostResponse';
import EvidenceSubmission from '@/models/EvidenceSubmission';

export default {
  components: {
    BaseFilesList,
    BaseTextEditorDisplay
  },
  props: {
    postId: {
      type: Number,
      required: true
    },
    criteria: {
      type: Array,
      default: null
    },
    previousEvidence: {
      type: EvidenceSubmission,
      default: null
    }
  },
  computed: {
    prevSubmission() {
      return this.previousEvidence
        ? PostResponse.query()
            .where('evidence_submission_id', this.previousEvidence.id)
            .where('post_id', this.postId)
            .with('attachments')
            .first()
        : null;
    },
    prevEvaluation() {
      return this.previousEvidence
        ? PostResponse.query()
            .where('evidence_submission_id', this.previousEvidence.id)
            .where('assessment_evaluation_id', (value) => value !== null)
            .where('post_id', this.postId)
            .with('assessment_evaluation')
            .first()
        : null;
    },
    evaluationResult() {
      const assessment_evaluation = this.prevEvaluation.assessment_evaluation;
      const criteria = this.criteria.find((c) => c.id === assessment_evaluation.criterion);

      if (assessment_evaluation.additional_criterion) {
        const add = criteria.additional_criteria?.find(
          (c) => c.id === assessment_evaluation.additional_criterion
        );
        return add.title ? add.title : '';
      }

      return criteria[assessment_evaluation.pass ? 'pass_title' : 'not_yet_title'];
    },

    badgeStatusClass() {
      return this.prevEvaluation.assessment_evaluation.pass
        ? 'badge-text-info'
        : this.prevEvaluation.assessment_evaluation.pass !== true &&
          this.prevEvaluation.assessment_evaluation.additional_criterion
        ? 'badge-text-warning'
        : 'badge-text-danger';
    },

    backgroundCollapse() {
      return this.badgeStatusClass === 'badge-text-info'
        ? 'background-info'
        : this.badgeStatusClass === 'badge-text-warning'
        ? 'background-warning'
        : 'background-danger';
    }
  }
};
</script>

<style lang="scss" scoped>
.post-evidence-previous-wrapper {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  .text__criteria-description {
    white-space: pre-line;
    word-break: break-word;
  }

  .collapse-wrapper {
    cursor: pointer;
    border-radius: 10.4px;
    border: 1px solid #d1d2db;
    overflow: hidden;

    .badge-text-info {
      color: #0c6b7e;
    }

    .background-info {
      color: #3b3e66;
      background-color: #cff3f8;
    }

    .badge-text-warning,
    .background-warning {
      color: #824224;
    }

    .background-warning {
      background-color: #fde4d5;
    }

    .badge-text-danger,
    .background-danger {
      color: #841e30;
    }

    .background-danger {
      background-color: #fed6da;
    }

    .header__feedback-from-assessor {
      background-color: #d9e9ff;
      color: #255091;
    }
  }

  .collapse-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    gap: 1.25rem;

    .collapse-header__title {
      flex: 1;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      align-items: center;
      gap: 0.5rem;
      margin-bottom: 0.25rem;

      .criterion-evaluation {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 4px 10px;
        font-size: 12px;
        border-radius: 10rem;
        background: #ffffff;

        .text-evaluation-result {
          text-transform: uppercase;
        }
      }
    }
  }

  .title-left {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .collapse-header-wrapper {
    padding: 12px 20px;
  }

  .collapse-body {
    border-top: 1px solid #d1d2db;
  }

  .collapse-content {
    display: flex;
    flex-direction: column;
    padding: 16px 20px;

    .ql-editor--display {
      padding: 0;
      margin: 0;
    }

    .content-text + .content-file-list {
      margin-top: 0.75rem;
    }
  }

  .collapse-content__previous-evidence {
    height: 100%;
    max-height: 240px;
    overflow-y: auto;
  }

  .collapse-content__rubric {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }

  .collapse-body.show {
    padding: 0;
  }

  .not-collapsed .icon-expanded {
    transform: rotate(180deg);
    transition: transform 0.3s ease;
  }

  .collapsed .icon-expanded {
    transition: transform 0.3s ease;
  }

  .text__criterion {
    display: flex;
    gap: 1rem;
    width: 100%;
  }
}
</style>
